/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recovery_Codes_TitleInputs */

const en_recovery_codes_title = /** @type {(inputs: Recovery_Codes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your recovery codes`)
};

const de_recovery_codes_title = /** @type {(inputs: Recovery_Codes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine Wiederherstellungs­codes`)
};

/**
* | output |
* | --- |
* | "Your recovery codes" |
*
* @param {Recovery_Codes_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const recovery_codes_title = /** @type {((inputs?: Recovery_Codes_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recovery_Codes_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_recovery_codes_title(inputs)
	return en_recovery_codes_title(inputs)
});